<script setup>
const props = defineProps({
  direction: {
    type: String,
    default: "down", // up, down
  },
});
</script>
<template>
  <svg
    viewBox="0 0 6 5"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    :class="{
      'transform rotate-180': props.direction === 'up',
      'transform rotate-0': props.direction === 'down',
    }"
  >
    <path d="M3.39404 4.5L0.795967 0L5.99212 0L3.39404 4.5Z" />
  </svg>
</template>
